module.exports = __webpack_public_path__ + "img/edit-icon.3c79a97c.svg";